module.exports = "<div class=\"col-lg-12 col-md-12 col-12 px-0\">\n  <router-outlet></router-outlet>\n</div>\n\n\n\n\n"


//////////////////
// WEBPACK FOOTER
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main